import React, {Component} from "react";
import {connect} from 'react-redux';
import {Grid} from "@mui/material";
import AnnotationsExpandableListBlood from "./annotationsExpandableListBlood";
import {locateAnnotationOnMap} from "../utils/map_utils";
import {AnnotationsConstants, Loader} from "../../../utils/const";
import {getBloodAnnotationLayer,} from "../utils/layers_info";
import {updateActiveAnnoDrawer} from "../../../redux_actions/gamma.state.action";
import {annotationsApp} from "../app_maker";

class BloodAnnotationsApp extends Component {

	componentDidMount() {
		//change anno drawer on mounting only
		let bloodAnnotationAppLayer = getBloodAnnotationLayer(this.props.gammaState);
		let bloodAnnotationAppDrawer = bloodAnnotationAppLayer.anno_drawer;
		this.props.dispatch(updateActiveAnnoDrawer(bloodAnnotationAppDrawer))
	}

	componentWillUnmount() {
		let annoAppDrawer = annotationsApp.drawer;
		this.props.dispatch(updateActiveAnnoDrawer(annoAppDrawer))
	}

	emptyComponent = () => <Grid>
		No Blood Annotations Available
	</Grid>;

	render() {
		if (this.props.loadingState.loading) {
			return <Loader/>
		}
		// this.initState();
		if (!this.props.bloodAnnotationState) return this.emptyComponent();
		let annotations;
		if (this.props.bloodAnnotationState.annotations)
			annotations = this.props.bloodAnnotationState.annotations.filter(annotation => annotation.anno_drawer === 5); //WBC dumped as anno_drawer 5
		if (annotations === undefined || annotations.length === 0)
			return this.emptyComponent();

		return <AnnotationsExpandableListBlood annotations={annotations}
		                                       slideId={this.props.slide.id}
		                                       onAnnotationClick={(annotation) =>
												   locateAnnotationOnMap(this.props.slidemap, annotation, false)}
		                                       colors={AnnotationsConstants.ANNO_COLORS}
		                                       showDownload={false}/>
	}
}

const mapStateToProps = (state) => {
	let loadingState = state.slideLoadingReducer;
	let {activeMapId} = state.gammaStateReducer;
	let {slide, slidemap, bloodAnnotationState} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, slide, slidemap, bloodAnnotationState, loadingState};
}

export default connect(mapStateToProps)(BloodAnnotationsApp)
